import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "amount", "token"]
  static outlets = ["app--wallet", "visibility"]
  
  connect() {
    localStorage.clear()
    this.amount = "0"
    this.tokenSymbol = "USDC"
    this.updateDisplay()
  }
  
  press(event) {
    const key = event.currentTarget.dataset.value
    if (key === "." && this.amount.includes(".")) return
    
    if (this.amount === "0" && key !== ".") {
      this.amount = key
    } else {
      this.amount += key
    }
    this.updateDisplay()
  }
  
  delete() {
    if (this.amount.length === 1) {
      this.amount = "0"
    } else {
      this.amount = this.amount.slice(0, -1)
    }
    this.updateDisplay()
  }
  
  updateDisplay() {
    this.displayTarget.textContent = `$${this.amount}`
    // Convert amount to cents by removing decimal point and converting to integer
    const amountInCents = Math.round(parseFloat(this.amount) * 100)
    this.amountTarget.value = amountInCents
    this.tokenTarget.value = this.tokenSymbol
  }
}